"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRecruiterLiteData = exports.isSalesNavData = void 0;
function isSalesNavData(data) {
    return (!!data && ('companyName' in data || 'roleExperience' in data || 'companyExperience' in data));
}
exports.isSalesNavData = isSalesNavData;
function isRecruiterLiteData(data) {
    return (!!data &&
        ('industry' in data ||
            'jobExperiences' in data ||
            'educationExperiences' in data ||
            'interest' in data));
}
exports.isRecruiterLiteData = isRecruiterLiteData;
